<template>
    <div class="container clearfix">
        <div class="registration-form">
            <fieldset>
                <legend>新しいパスワードを入力</legend>
                <hr>
                <div class="form-column">
                    <input name="password" type="password" class="form-control" placeholder="新しいパスワード" id="password" maxlength="255" v-model="profile.password">
                </div>
                <div class="form-column">
                    <input name="password_confirmation" type="password" class="form-control" placeholder="新しいパスワード(確認)" maxlength="255" id="password_confirmation" v-model="profile.password_confirmation">
                </div>
            </fieldset>
            <div class="registration-btn">
                <button class="btn btn-primary" @click="updatePassword">更新</button>    
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { Message } from 'element-ui'
import $userRepository from '../../backend/userRepository'

export default {
    data() {
        return {
            profile: {
                id: this.$route.query.id,
                password: '',
                password_confirmation: ''
            },
            errorMessage: '',
            validate_flag: false,
            response: null
        }
    },
    computed: {
        ...mapState({
            errorMessage: state => (state.auth.errorMessage)
        })
    },
    mounted() {
        this.$store.commit('auth/setErrorMessage', null)
    },
    methods: {
        // ユーザ登録
        async updatePassword() {
            this.validate();
            if(this.validate_flag) {
                this.validate_flag = false;
                return;
            }
            
            this.errorMessage = '';
            
            this.response = await $userRepository.updatePassword(this.profile);
            if(this.response.status === 200) {
                Message({  // 画面遷移中に消えないように、他のMessageコンポーネントとは少し設定を変えています
                    message: 'パスワードを更新しました',
                    type: 'success',
                    duration: 0,
                    showClose: true
                });
                this.$router.push({ path: '/'});
            }
            // バックエンドで検知したエラーはerrorMessageコンポーネントで表示する
        },
        // formではなくdataを利用してバックエンドに送信するため、フロントで検知したエラーはinput属性ではなく下記でバリデーションチェックを行う
        validate() {
            if (!this.profile.password
                || !this.profile.password_confirmation) {
                Message({
                    message: '未入力の項目があります',
                    type: 'error'
                });
                this.validate_flag = true;
                return;
            }
            if (this.profile.password != this.profile.password_confirmation) {
                Message({
                    message: '新しいパスワードと確認用パスワードが一致しません',
                    type: 'error'
                });
                this.validate_flag = true;
            }
        }
    }
}
</script>

 <style scoped>
 .registration-form {
     position: absolute;
     top: 50%;
     left: 50%;
     transform: translate(-50%, -50%);
     width: 80%;
     max-width: 400px;
 }
 .form-column {
     margin-bottom: 10px;
 }
 .registration-btn {
     text-align: center;
     margin: 10px;
 }

 </style>